import React, { useEffect, useState } from 'react';
import { consumeWorkspaceEntry, workspaceEntryRecoveryUrl } from './workspaceEntry';

export default function WorkspaceEntryGate({ children }) {
  const [state, setState] = useState('opening');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (state !== 'opening') return undefined;
    let active = true;
    consumeWorkspaceEntry().then(() => {
      if (active) setState('ready');
    }).catch((error) => {
      if (!active) return;
      if (error.code === 'entry_expired') {
        const url = workspaceEntryRecoveryUrl({ automatic: true });
        if (url) {
          window.location.replace(url);
          return;
        }
      }
      setMessage(error.code === 'entry_expired'
        ? 'Your sign-in link needs refreshing. Your company setup is saved.'
        : 'The connection was interrupted while opening your workspace. Your company setup is saved.');
      setState('failed');
    });
    return () => { active = false; };
  }, [state]);

  if (state === 'ready') return children;
  return (
    <main className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <section className="max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <h1 className="text-xl font-semibold text-slate-900">Opening your workspace</h1>
        {state === 'opening' ? <p role="status" className="mt-3 text-slate-600">Connecting your signed-in account…</p> : <>
          <p role="alert" className="mt-3 text-slate-600">{message}</p>
          <button className="mt-6 rounded-lg bg-slate-900 px-4 py-2 text-white" onClick={() => setState('opening')}>Try again</button>
          <button className="mt-3 block text-sm font-medium underline" onClick={() => window.location.replace(workspaceEntryRecoveryUrl())}>Continue through signup</button>
        </>}
      </section>
    </main>
  );
}
